export default __webpack_public_path__ + "static/media/IMG_20220102_084852.b8605fc1.png";